export var EAtomicBlockImageAlignment;
(function (EAtomicBlockImageAlignment) {
    EAtomicBlockImageAlignment["Left"] = "left";
    EAtomicBlockImageAlignment["Center"] = "center";
    EAtomicBlockImageAlignment["Right"] = "right";
})(EAtomicBlockImageAlignment || (EAtomicBlockImageAlignment = {}));
